import React, { Component } from 'react';
import { Dropdown, Select, Table, message } from 'antd';
import Loader from '../../../Common/Component/Loader';
import DataTable from './Datatable';
import { map } from 'lodash';
import {errorHandle} from "../../../Common/errorHandle";
const { Option } = Select

class ExpiredCard extends Component {

  state = {
    expired_card_list: [],
    selectedRowKeys: [],
    franchiseList: [],
    expired_list_pagination: { current: 1, showSizeChanger: false, pageSize: 15, ordering: "", },
    expired_list_filter: {},
    search_value: '',
    active_pagination: '15',
    loader: false
  }

  componentDidMount = () => {
    this.setState({
      loader: true
    })
    // Get Expired Card List
    this.props.getExpiredCardListing({ limit: 15, offset: 0 });
    //Get Franchise List
    this.props.getFranchiseList({ limit: 15, offset: 0 });
  }


  UNSAFE_componentWillReceiveProps = (props) => {
    let { expired_list_pagination } = this.state;
    // Get Expired Card List
    if (Object.keys(props.ExpiredCard.data).length > 0 && props.ExpiredCard.data !== this.props.ExpiredCard.data) {
      expired_list_pagination.total = props.ExpiredCard.data.count;

      this.setState({
        expired_card_list: props.ExpiredCard.data.results,
        expired_list_pagination,
        loader: false
      })
    }

    if (Object.keys(props.ExpiredCard.errors).length > 0 && props.ExpiredCard.errors !== this.props.ExpiredCard.errors) {
      errorHandle(props.ExpiredCard.errors)
      this.setState({
        loader: false,
      })
    }

    //get franchise list
    if (Object.keys(props.FranchiseList.data).length > 0 && props.FranchiseList.data !== this.props.FranchiseList.data) {
      this.setState({
        franchiseList: props.FranchiseList.data.results,
        loader: false
      })
    }
    if (Object.keys(props.FranchiseList.errors).length > 0 && props.FranchiseList.errors !== this.props.FranchiseList.errors) {
      // display error messsage
      errorHandle(props.FranchiseList.errors)
      this.setState({ loader: false })
    }


    //Print Invoice
    if (Object.keys(props.PrintedInvoice.data).length > 0 && props.PrintedInvoice.data !== this.props.PrintedInvoice.data) {
      //Print Invoice
      this.setState({
        loader: false,
        selectedRowKeys: [],
        set_table_active_action: ''
      });
      var byteCharacters = atob(props?.PrintedInvoice?.data?.data);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var file = new Blob([byteArray], { type: 'application/pdf;base64' });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    }
    if (Object.keys(props.PrintedInvoice.errors).length > 0 && props.PrintedInvoice.errors !== this.props.PrintedInvoice.errors) {
      message.error('Something went wrong', 10);
      this.setState({
        loader: false,
        set_table_active_action: ''
      });
    }


    //Send Reminder
    if (Object.keys(props.SendInvoiceReminder.data).length > 0 && props.SendInvoiceReminder.data !== this.props.SendInvoiceReminder.data) {
      //Print Invoice
      this.setState({
        // loader: false,
        selectedRowKeys: [],
        set_table_active_action: ''
      });
      message.success(props?.SendInvoiceReminder?.data?.message, 10);
      // Get Expired Card List
      this.props.getExpiredCardListing({ limit: 15, offset: 0 });
    }
    if (Object.keys(props.SendInvoiceReminder.errors).length > 0 && props.SendInvoiceReminder.errors !== this.props.SendInvoiceReminder.errors) {
      errorHandle(props.SendInvoiceReminder.errors)
      this.setState({
        loader: false,
        set_table_active_action: ''
      });
    }


  }

  // on search
  onSearch = (e) => {
    const search_value = e.target.value;
    if (search_value?.length >= 3 || search_value?.length === 0) {
      this.props.getExpiredCardListing({ 'search': e.target.value, limit: 15, offset: 0 })
    }
    this.setState({search_value: search_value})
  }

  //set page limit
  setMessagePageLimit = (custom_limit) => {
    let { search_value, expired_list_pagination, expired_list_filter } = this.state;
    expired_list_pagination = Object.assign(expired_list_pagination, { 'current': 1, 'pageSize': custom_limit });

    this.setState({
      expired_list_pagination,
      loader: true,
      active_pagination: custom_limit,
    })

    let data = {
      offset: 0, limit: custom_limit, search: search_value, ...expired_list_filter
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getExpiredCardListing(data);
  }


  //Selct Table Row checkbox
  onSelectedRowKeysChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  }

  //Pagination
  ExpiredPagintaion = (pagination) => {
    let { expired_list_pagination, active_pagination, search_value, expired_list_filter } = this.state;

    expired_list_pagination = Object.assign(expired_list_pagination, { 'current': pagination.current });

    this.setState({
      expired_list_pagination,
      loader: true
    })

    let data = {
      offset: (pagination.current * 10) - 10,
      limit: active_pagination,
      ...expired_list_filter,
      search: search_value,
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getExpiredCardListing(data)
  }

  //Render Table
  renderExpiredTable = () => {
    let { expired_card_list, selectedRowKeys, active_pagination, expired_list_pagination } = this.state;

    return (
      <React.Fragment>
        <Table
          rowKey={record => record.uuid}
          dataSource={expired_card_list}
          pagination={expired_list_pagination}
          onChange={this.ExpiredPagintaion}
          rowSelection={{
            type: 'checkbox',
            selectedRowKeys,
            onChange: this.onSelectedRowKeysChange
          }}
          columns={DataTable.AllExpiredCardList(this)} />

        {expired_card_list.length > 0 ?
          <ul className="pagination_page_size">
            <li>
              <span>Show:</span>
            </li>
            <li>
              <span
                onClick={() => { this.setMessagePageLimit('15') }}
                className={active_pagination === '15' ? 'active' : ''}
              >15</span>
            </li>
            <li>
              <span
                className={active_pagination === '30' ? 'active' : ''}
                onClick={() => { this.setMessagePageLimit('30') }}>30</span>
            </li>
            <li>
              <span
                className={active_pagination === '60' ? 'active' : ''}
                onClick={() => { this.setMessagePageLimit('60') }}>60</span>
            </li>
          </ul> : ''}
      </React.Fragment>
    )
  }


  render() {
    let { franchiseList, active_pagination, loader, selectedRowKeys, expired_list_filter } = this.state;
    const menu = (
      <div className="table_inner_filter_select">
        <ul>
          {/* <li onClick={() => {
            if (selectedRowKeys.length > 0) {
              this.setState({ loader: true });
              this.props.printInvoice({ multiple_invoices_uuid: selectedRowKeys.join(',') })
            }


          }}>Print Invoices</li> */}
          <li onClick={() => {

            if (selectedRowKeys.length > 0) {
              this.setState({ loader: true });
              this.props.sendInvoiceReminder({ expiry_card_reminder: true, multiple_invoices_uuid: selectedRowKeys.join(',') })
            }

          }}>Send Reminders</li>
        </ul>
      </div>
    )
    return (
      <div className="account_expired_card">
        <ul className="breadcrumb"><li onClick={() => { this.props.ChangeComponent(0) }}><span className="pointer"><i className="las la-angle-left"></i> Back to All Accounts</span></li></ul>

        <h2 style={{ 'padding': '0 25px 0 25px', 'margin': '0' }}>Expiring Customer Payment Methods</h2>

        <div className="filter_wrapper acc-wrap flex bg-transparent" style={{ padding: '10px 25px 0 25px' }}>
          <div className="left_side mr-2">

            <Dropdown overlay={menu} trigger='click'>
              <button className="btn btn-warning" >Batch Actions <i className="las la-angle-down"></i></button>
            </Dropdown>
          </div>
          <div className="right_side">
            <div className="form-group flex ai-center w-100 flex-end">
              <div className="fitem fitem-rinner licon">
                <div className="fitem-ricon">
                  <i className="las la-search"></i>
                </div>
                <input
                  type="text"
                  onChange={(e) => this.onSearch(e)}
                  onKeyPress={event => {
                    if (event.key === 'Enter') {
                      this.onSearch({target: {value: this.state.search_value}})
                    }
                  }}
                  placeholder="Search acc number, customer address or contact details"
                  className="form-control flex-1" />
              </div>
              <div className="fitem">
                <Select
                  className="swhite franchise_filter"
                  showSearch
                  showArrow={true}
                  suffixIcon={<i className="las la-angle-down"></i>}
                  defaultValue=""
                  disabled={this.props?.is_disable_franchise ? true : false}
                  onChange={(e) => {
                    this.setState({
                      loader: true,
                      expired_list_filter: {
                        ...expired_list_filter,
                        /**
                         * AUTHOR: RITESH SOLANKI
                         * Changed: 01-10-2021 03:34 PM (Friday)
                         * <DOOD-3101>Replace user__serviceorder__field_office__uuid with user__field_office__uuid. Changed on Line #288 & #291</DOOD-3101>
                         */
                        user__field_office__uuid: e
                      }
                    })
                    this.props.getExpiredCardListing({ user__field_office__uuid: e, limit: active_pagination, offset: 0 })
                  }}
                  onSearch={(e) => { this.props.getFranchiseList({ search: e }) }}
                  onBlur={() => { this.props.getFranchiseList({ limit: 10, offset: 0 }) }}

                >
                  <Option value="">All</Option>
                  {map(franchiseList, (item) => {
                    return (
                      <Option key={item.uuid}>{item.name}</Option>
                    )
                  })}
                </Select>
              </div>
            </div>
          </div>
        </div>

        <div className="block-row pt-10">
          {this.renderExpiredTable()}
        </div>
        {loader ? <Loader /> : ''}
      </div>
    );
  }
}

export default ExpiredCard;